import e from "react";
import { classPrefix as t } from "../utils/helpers.js";
var a = function (a) {
  var c = a.id,
    l = a.labels,
    n = a.value,
    o = a.disabled,
    r = a.onChangeHandler,
    s = a.selectOptions,
    i = a.ref;
  return e.createElement("div", {
    style: {
      display: "flex",
      flexDirection: "column"
    },
    className: "".concat(t, "_select-container-").concat(c)
  }, !l.hide && e.createElement("label", {
    htmlFor: "".concat(t, "_select-").concat(c)
  }, l.main), e.createElement("select", {
    id: "".concat(t, "_select-").concat(c),
    value: n,
    disabled: o,
    onChange: r,
    ref: i,
    className: "".concat(t, "_select-").concat(c)
  }, e.createElement("option", {
    value: -1,
    disabled: !0
  }, l.placeholder), s));
};
export { a as SelectRenderer };